<div class="popup-wrapper"
     [class.container]="container"
     [class.is-active]="show">
    <div class="popup-wrapper__inner" *ngIf="show">
        <button class="popup-wrapper__close" (click)="closePopup()"></button>
        <div class="popup-wrapper__scrolled">
            <ng-content></ng-content>
        </div>
    </div>
</div>
